import { cn } from "@/lib/utils";

type SiteLogoProps = {
  className?: string;
};

/**
 * KPKL brand logo — AI-generated neon brand mark.
 * Gradient lime-green → purple "KPKL" wordmark with neon-cyan broadcast arcs,
 * transparent background. Source: /kpkl-logo.png
 */
export function SiteLogo({ className }: SiteLogoProps) {
  return (
    <img
      src="/kpkl-logo.png"
      alt="KPKL Radio"
      role="img"
      className={cn("h-9 w-auto shrink-0 object-contain", className)}
    />
  );
}
